import React, { useRef, useState, useEffect } from 'react'
import axios from 'axios'
import { MultiSelect } from "react-multi-select-component"

import Panel from '../ui/Panel'
import Btn from '../ui/Btn'
import VideoModal from '../ui/VideoModal'
import CoachesVideosLang from './CoachesVideosLang'
import CoachesSelectVideo from './CoachesSelectVideo'
import {
  Notice,
  Confirm,
  Field,
  Sheet,
  ClipGrid,
  ClipCard,
  EmptyState,
  SkeletonForm,
  IconTrash,
  IconPlus,
} from './media'
import './media.css'

/*
 * COACHES' VIDEO — the form.
 *
 * Requests, payloads and response handling are untouched:
 *   GET    admin/coaches/coachvideo/{id}
 *   GET    admin/sports
 *   GET    admin/coaches/tags
 *   POST   admin/coaches            (the whole record object, TagsStr included)
 *   DELETE admin/coaches/{id}
 *
 * The record is one thing, so it is one form with one save: details, tags,
 * level and the clip itself. The clip is a poster card that plays in the shared
 * VideoModal — the same card the picker shows — instead of an embedded player
 * with a hard-coded stream URL.
 */

export default function CoachesVideosForm(props) {

  const [record, setRecord] = useState({
    id: 0,
    IsActive: 1,
    Descr: '',
    IsChallenge: 0,
    Tags: [],
    VideoID: '',
    TagsStr: ''
  })
  const [isLoading, setIsLoading] = useState(false)
  const [descr, setDescr] = useState('')
  const [sports, setSports] = useState([])
  const [tags, setTags] = useState([])
  const [allTags, setAllTags] = useState([])
  const [selected, setSelected] = useState([])
  const [show, setShow] = useState(false)
  const [note, setNote] = useState(null)
  const [confirmDel, setConfirmDel] = useState(false)
  const [saving, setSaving] = useState(false)
  const [playing, setPlaying] = useState(false)

  const timerRef = useRef(null)

  const levels = [
    'Beginner', 'Intermediate', 'Advanced', 'Pro'
  ]

  const handleClose = () => setShow(false)

  useEffect(() => {
    loadData(props.id)
    loadSports()
    loadVideoTags()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id])

  useEffect(() => () => { if (timerRef.current) window.clearTimeout(timerRef.current) }, [])

  useEffect(() => {

    setTags(allTags.filter(item => item.SportID == record.SportID))
  }, [allTags, record.SportID])

  const loadData = (id) => {
    setIsLoading(true)
    if (id != 0) {
      axios.get(process.env.REACT_APP_API_SERVER + 'admin/coaches/coachvideo/' + id, {
        headers: {
          'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
        }
      })
        .then(res => {
          setRecord(res.data.results)
          setDescr(res.data.results.Descr)
          setSelected(res.data.results.Tags.split(',').map(item => { return { label: item, value: item } }))

          setIsLoading(false)

        }).catch(err => {
          setIsLoading(false)
          setNote({ kind: 'crit', text: 'The video could not be loaded.' })

        })
    } else {
      setRecord({
        id: 0,
        IsActive: 1,
        Descr: '',
        IsChallenge: 0,
        Tags: [],
        VideoID: '',
        TagsStr: ''
      })
      setIsLoading(false)
    }
  }

  const loadSports = () => {
    setIsLoading(true)
    axios.get(process.env.REACT_APP_API_SERVER + 'admin/sports', {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {
        setSports(res.data.results)
        setIsLoading(false)

      }).catch(err => {
        setIsLoading(false)
        setNote({ kind: 'crit', text: 'The sports could not be loaded.' })
      })
  }


  const loadVideoTags = () => {
    setIsLoading(true)
    axios.get(process.env.REACT_APP_API_SERVER + 'admin/coaches/tags', {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {
        setAllTags(res.data.results)
        setIsLoading(false)

      }).catch(err => {
        setIsLoading(false)
        setNote({ kind: 'crit', text: 'The tags could not be loaded.' })
      })
  }


  useEffect(() => {
    var TagsStr = ''
    selected.forEach((item, index) => {
      TagsStr = TagsStr + item.label
      if (index < selected.length - 1) {
        TagsStr = TagsStr + ','
      }
    })
    setRecord({ ...record, Tags: selected, TagsStr })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])


  const save = (e) => {
    e.preventDefault()

    const obj = { ...record }
    setSaving(true)
    setNote(null)

    axios.post(process.env.REACT_APP_API_SERVER + 'admin/coaches', obj, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {
        setSaving(false)
        setNote({ kind: 'good', text: res.data.msg || 'Saved.' })
        timerRef.current = window.setTimeout(() => { props.showForm(0, false) }, 900)
      }).catch(err => {
        setSaving(false)
        setNote({ kind: 'crit', text: 'Something went wrong, please try again' })
      })
  }



  const deleteRecord = () => {
    setConfirmDel(false)
    axios.delete(process.env.REACT_APP_API_SERVER + 'admin/coaches/' + props.id, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {
        if (res.data.err == 0) {
          props.loadData()
          props.showForm(0, false)
        } else {
          setNote({ kind: 'crit', text: res.data.msg || 'Something went wrong, please try again' })
        }

      }).catch(err => {
        setNote({ kind: 'crit', text: 'Something went wrong, please try again' })
      })
  }


  const tagsList = tags.map(item => {
    return (
      { label: item.Title, value: item.Title }
    )
  })

  const sportsList = sports.map(item => {
    return (
      <option key={item.SportID} value={item.SportID}>{item.SportName}</option>
    )
  })

  const levelsList = levels.map(item => {
    return (
      <option key={item} value={item}>{item}</option>
    )
  })


  const sportSelected = (SportID) => {
    setSelected([])
    setRecord({ ...record, SportID, Tags: [] })
    setTags(allTags.filter(item => item.SportID == SportID))
  }

  const isNew = props.id == 0
  const hasClip = !!(record.VideoID && String(record.VideoID).length > 0)
  const clips = hasClip ? [{ fileId: record.VideoID, name: record.Title || record.VideoID, subtitle: record.VideoID }] : []

  return (
    <div className="md-stack">
      <Panel
        title={isNew ? 'New Coaches Video' : 'Video Details'}
        subtitle={isNew ? 'Fill in the details and pick a video' : record.Title || ''}
        actions={<Btn onClick={() => props.showForm(0, false)}>List</Btn>}
      >
        {note ? <Notice kind={note.kind} onClose={() => setNote(null)}>{note.text}</Notice> : null}

        {isLoading && !isNew && !record.Title ? (
          <SkeletonForm rows={4} />
        ) : (
          <form className="md-form" onSubmit={save}>
            <div className="md-group">
              <Field label="Sport" htmlFor="cv-sport" required>
                <select
                  id="cv-sport"
                  className="md-select"
                  required
                  value={record.SportID == null ? '' : record.SportID}
                  onChange={(e) => sportSelected(e.target.value)}
                >
                  <option value=''>[Select sport]</option>
                  {sportsList}
                </select>
              </Field>

              <Field label="Video Title" htmlFor="cv-title" required>
                <input
                  id="cv-title"
                  className="md-input"
                  type="text"
                  required
                  value={record.Title == null ? '' : record.Title}
                  onChange={(e) => setRecord({ ...record, Title: e.target.value })}
                />
              </Field>

              <Field label="Description" htmlFor="cv-descr" className="md-span">
                <textarea
                  id="cv-descr"
                  className="md-textarea"
                  rows={3}
                  value={record.Descr == null ? '' : record.Descr}
                  onChange={(e) => setRecord({ ...record, Descr: e.target.value })}
                />
              </Field>

              <Field label="Level" htmlFor="cv-level" required>
                <select
                  id="cv-level"
                  className="md-select"
                  required
                  value={record.Level == null ? '' : record.Level}
                  onChange={(e) => setRecord({ ...record, Level: e.target.value })}
                >
                  <option value=''>[Select level]</option>
                  {levelsList}
                </select>
              </Field>

              <Field label="Active" htmlFor="cv-active">
                <select
                  id="cv-active"
                  className="md-select"
                  value={record.IsActive == null ? '1' : record.IsActive}
                  onChange={(e) => setRecord({ ...record, IsActive: e.target.value })}
                >
                  <option value='1'>YES</option>
                  <option value='0'>NO</option>
                </select>
              </Field>

              <Field
                label="Tags"
                className="md-span"
                hint={tags.length === 0 ? 'Pick a sport first to see its tags.' : ''}
              >
                <div className="md-multi">
                  <MultiSelect hasSelectAll={false} options={tagsList} value={selected} onChange={setSelected} labelledBy="Select" />
                </div>
              </Field>
            </div>

            <div className="md-field">
              <span className="md-label">Video</span>

              {hasClip ? (
                <ClipGrid single>
                  <ClipCard
                    fileId={record.VideoID}
                    name={record.Title || record.VideoID}
                    subtitle={record.VideoID}
                    onPlay={() => setPlaying(true)}
                  >
                    <Btn onClick={() => setShow(true)}>Change Video</Btn>
                  </ClipCard>
                </ClipGrid>
              ) : (
                <EmptyState
                  title="No video"
                  hint="A video is required before you can save."
                  action={<Btn variant="accent" onClick={() => setShow(true)}>{IconPlus}Add Video</Btn>}
                />
              )}
            </div>

            {confirmDel ? (
              <Confirm
                text={<b>DELETE THE ENTIRE VIDEO!!!! ARE YOU SURE???</b>}
                confirmLabel="Delete"
                cancelLabel="Cancel"
                onConfirm={deleteRecord}
                onCancel={() => setConfirmDel(false)}
              />
            ) : null}

            <div className="md-actions md-actions-split">
              {!isNew ? (
                <Btn className="md-danger md-actions-left" onClick={() => setConfirmDel(true)}>
                  {IconTrash}
                  Delete
                </Btn>
              ) : <span className="md-actions-left" />}

              {/* A record loaded with a null VideoID used to slip past the old
                  `record.VideoID?.length == 0` guard and offer a save with no
                  clip. `hasClip` is the same test the card above already uses. */}
              <Btn variant="accent" type="submit" disabled={saving || !hasClip}>
                {saving ? 'Saving...' : 'Save'}
              </Btn>
            </div>
          </form>
        )}
      </Panel>

      {!isNew ? <CoachesVideosLang CoachVideoID={props.id} /> : null}

      {show ? (
        <Sheet title="Add / Change Video" subtitle="Video library" onClose={handleClose}>
          <CoachesSelectVideo id={props.id} record={record} setRecord={setRecord} handleClose={handleClose} />
        </Sheet>
      ) : null}

      {playing && hasClip ? (
        <VideoModal
          items={clips}
          index={0}
          title="Coaches Video"
          onIndex={() => {}}
          onClose={() => setPlaying(false)}
        />
      ) : null}
    </div>
  )
}
